<template>
  <!-- :style="'min-height:565px;height:'+height+'px'" -->
  <div :class="{bannerBox:true,h900:title=='contact'}" :id="title+lang">
    <div :class="{banner:true,h900:title=='contact'}">
      <div class="bannerText" >
        <div :class="[prjPosit,'prjName']" v-html="$t(title+'.banTitle')"></div>
        <div :class="{'decp':true,'lsNone':lang=='en'}" >{{$t(title+'.banTips')}}</div>
        <ul v-if="title=='contact'">
          <li>
            <img :src="adress" alt="">
            <div class="msg">
              <p class="name">{{$t('contact.summary.tit1')}}</p>
              <p class="value">{{$t('contact.summary.tips1')}}</p>
            </div>
          </li>
          <li>
            <img :src="number" alt="">
            <div class="msg">
              <p class="name">{{$t('contact.summary.tit2')}}</p>
              <p class="value">{{$t('contact.summary.tips2')}}</p>
            </div>
          </li>
          <li>
            <img :src="mail" alt="">
            <div class="msg">
              <p class="name">{{$t('contact.summary.tit3')}}</p>
              <p class="value">{{$t('contact.summary.tips3')}}</p>
            </div>
          </li>
        </ul>
      </div>
        <video v-if="title=='home'" poster="@/assets/images/poster.png" style="width: 100%;" autoplay loop muted="true">
          <source src="@/assets/images/video.mp4" type="video/mp4">
        </video>
        <!-- :style="'min-height:565px;width: 100%;height:'+height+'px'" -->
      <img v-else :src="bgImg" alt="" :class="{bgBottom:true,h900:title=='contact'}" />
    
    </div>
  </div>
</template>
<script>
  import adress from "@/assets/images/adress.png"
  import number from "@/assets/images/number.png"
  import mail from "@/assets/images/mail.png"
export default {
  name: "Banner",
  props: ["title","bgImg","height","project","prjPosit"],
  components: {
  },
  data() {
    return {
      adress:adress,
      number:number,
      mail:mail,
      lang: this.$i18n.locale,
    };
  }
};
</script>

<style lang="scss">
.bannerBox {
  width: 100%;
  .banner {
    position:relative;
    .bannerText{
      position:absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 22%;
     
      ul{
        padding-top:35px;
        li{
          display: flex;
          flex-direction:row;
          margin-top: 25px;
          align-items: center;
          img{
            width:50px;
            height:44px;
          }
          .msg{
            padding-left: 13px;
            .name{
              font-size:20px;
              font-family:PingFangSC-Semibold,PingFang SC;
              font-weight:600;
              color:rgba(255,255,255,1);
              line-height:28px;
            }
            .value{
              font-size:16px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(255,255,255,1);
              line-height:30px;
            }
          }
        }
      }
      .prjName{
          text-align: center;
          font-size:80px;
          font-family:YouSheBiaoTiHei;
          color:rgba(255,255,255,1);
          line-height:104px;
          text-shadow:0px 2px 20px rgba(0,0,0,0.1);
      }
      .leftP{
        font-size: 60px;
        line-height: 61px;
        text-align: left;
      }
      .decp{
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,0.7);
        letter-spacing:5px;
      }
      .lsNone{
        letter-spacing: 0;
      }
    }
    img {
      width: 100%;
      height: 565px;
    }
  }
}
#taitanen{
  .decp{
        width: 418px;
        text-align:center;
      }
}
</style>
